import { render, staticRenderFns } from "./mopaging.vue?vue&type=template&id=1c730f18&scoped=true&"
import script from "./mopaging.vue?vue&type=script&lang=js&"
export * from "./mopaging.vue?vue&type=script&lang=js&"
import style0 from "./mopaging.vue?vue&type=style&index=0&id=1c730f18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c730f18",
  null
  
)

export default component.exports